import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M5 21V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v17l-2.333-1.5-2.334 1.5L12 19.5 9.667 21l-2.334-1.5zM9 7h6m-6 4h6m-6 4h3"
    }, null, -1)
  ])))
}
export default { render: render }